import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import brand_1 from "../../assets/1.png";
import brand_2 from "../../assets/2.png";
import brand_3 from "../../assets/3.png";
import brand_4 from "../../assets/4.png";
import brand_5 from "../../assets/5.png";
import brand_6 from "../../assets/6.png";
import brand_7 from "../../assets/7.png";
import brand_8 from "../../assets/8.png";
import brand_9 from "../../assets/9.png";
import brand_10 from "../../assets/10.png";
import brand_11 from "../../assets/11.png";
import brand_12 from "../../assets/12.png";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useNavigate } from "react-router-dom";
import api, { url } from "../../utilis/api";

gsap.registerPlugin(ScrollTrigger);

const logosRow1 = [
  { id: 1, img: brand_1, link: "/fragrance?vendor=Adrienne" },
  { id: 2, img: brand_2, link: "/fragrance?vendor=Burberry" },
  { id: 3, img: brand_3, link: "/fragrance?vendor=Calvin" },
  { id: 4, img: brand_4, link: "/fragrance?vendor=Azzaro" },
  { id: 5, img: brand_5, link: "/fragrance?vendor=Armaf" },
  { id: 6, img: brand_6, link: "/fragrance?vendor=Carolina" },
];

const logosRow2 = [
  { id: 7, img: brand_7, link: "/fragrance?vendor=Bvlgari" },
  { id: 8, img: brand_8, link: "/fragrance?vendor=Versace" },
  { id: 9, img: brand_9, link: "/fragrance?vendor=Cartier" },
  { id: 10, img: brand_10, link: "/fragrance?vendor=Clinique" },
  { id: 11, img: brand_11, link: "/fragrance?vendor=Christian" },
  { id: 12, img: brand_12, link: "/fragrance?vendor=Adrienne" },
];

const Brands = ({ data }) => {
  const navigate = useNavigate();
  const [vendors, setVendors] = useState([]);
  const [row1, setRow1] = useState([]);
  const [row2, setRow2] = useState([]);
  const containerRef = useRef(null);
  const headingRef = useRef(null);
  const row1Refs = useRef([]);
  const row2Refs = useRef([]);
  const [loading, setLoading] = useState(true);
  const fetchVendors = async () => {
    try {
      const res = await api.get("/brands");
      const vendors = res.data.data || [];

      const formatted = vendors.map((v) => ({
        id: v._id,
        img: `${url}${v.image}`,
        link: `/fragrance?vendor=${encodeURIComponent(v.name)}`,
      }));

      const mid = Math.ceil(formatted.length / 2);
      setRow1([...formatted.slice(0, mid), ...formatted.slice(0, mid)]);
      setRow2([...formatted, ...formatted]);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false); // 👈 mark done
    }
  };

  useEffect(() => {
    fetchVendors();
  }, []);

  if (loading || row1.length === 0) return null;

  return (
    <div className="bg-white pb-10" ref={containerRef}>
      <div className="container mx-auto px-4 flex flex-col items-center gap-5">
        <h1
          ref={headingRef}
          className="font-syne text-2xl md:text-5xl font-bold text-gradient-white text-center"
        >
          {data?.title}
        </h1>

        {/* Row 1 */}
        <div className="w-full">
          <Swiper
            modules={[Autoplay]}
            slidesPerView={6}
            spaceBetween={30}
            loop={true}
            allowTouchMove={false}
            speed={4000}
            autoplay={{ delay: 0, disableOnInteraction: false }}
            breakpoints={{
              320: { slidesPerView: 2 },
              640: { slidesPerView: 3 },
              768: { slidesPerView: 4 },
              1024: { slidesPerView: 6 },
            }}
          >
            {row1.map((logo, idx) => (
              <SwiperSlide
                key={idx}
                className="py-[2rem] flex justify-center items-center hover:scale-110 transition-transform duration-300"
              >
                <img
                  // ref={addRow1Ref}
                  src={logo.img}
                  alt="Brand"
                  onClick={() => navigate(logo.link)}
                  className="cursor-pointer"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Row 2 */}
        <div className="w-full">
          <Swiper
            modules={[Autoplay]}
            slidesPerView={6}
            spaceBetween={30}
            loop={true}
            allowTouchMove={false}
            speed={4000}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              reverseDirection: true,
            }}
            breakpoints={{
              320: { slidesPerView: 2 },
              640: { slidesPerView: 3 },
              768: { slidesPerView: 4 },
              1024: { slidesPerView: 6 },
            }}
          >
            {row1.map((logo, idx) => (
              <SwiperSlide
                key={idx}
                className="py-[2rem] flex justify-center items-center hover:scale-110 transition-transform duration-300"
              >
                <img
                  // ref={addRow1Ref}
                  src={logo.img}
                  alt="Brand"
                  onClick={() => navigate(logo.link)}
                  className="cursor-pointer"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Brands;
